<script setup lang="ts">
import CustomButton from '@/components/CustomButton.vue';
import Dialog from '@/components/dialogs/Dialog.vue';
import { useAuthStore } from '@/stores/auth';
import { useEmployeeStore } from '@/stores/employee';
import toast from '@/utils/toast';
import { email, required } from '@/utils/validation';
import { ref, useTemplateRef } from 'vue';

const isDialogOpen = defineModel<boolean>();

const employeeStore = useEmployeeStore();
const authStore = useAuthStore();

const form = useTemplateRef('form');
const isLoading = ref(false);
const newEmailInput = ref('');
const passwordInput = ref('');

function closeDialog() {
    form.value?.reset();
    isDialogOpen.value = false;
}

async function changeEmail() {
    const validationResult = await form.value?.validate();
    if (!validationResult?.valid) return;
    isLoading.value = true;

    try {
        const result = await employeeStore.changeEmail(
            authStore.getLoggedInEmployee()._id,
            authStore.getLoggedInEmployee().email,
            newEmailInput.value,
            passwordInput.value
        );
        if (result.status !== 200) return;

        toast.success('EmailUpdated');
        closeDialog();
    } finally {
        isLoading.value = false;
    }
}
</script>

<template>
    <Dialog v-model="isDialogOpen" title="E-mailadres wijzigen" :isLoading="isLoading">
        <v-form ref="form" @submit.prevent>
            <v-text-field label="Nieuw e-mailadres" v-model="newEmailInput" required :rules="[required, email]" />
            <v-text-field label="Wachtwoord" v-model="passwordInput" type="password" required :rules="[required]" />
        </v-form>
        <template #actions>
            <v-spacer />
            <CustomButton @click="changeEmail" :loading="isLoading" text="Bevestigen" />
            <CustomButton color="red" @click="closeDialog" text="Annuleren" />
        </template>
    </Dialog>
</template>
